<template>
  <div class="wjPatrolStandardList">
    <div class="filters">
      <el-form :inline="true">
        <!-- 报事一级分类 -->
        <el-form-item>
          <el-select v-model="maintainType1" @change="changeSelect1">
            <el-option key :label="$t('lang.lbl_choose_inspection_typeName1')" :value="zero"></el-option>
            <el-option v-for="(item,index) in maintainType1List" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 报事二级分类 -->
        <el-form-item>
          <el-select v-model="maintainType2" @change="changeSelect2">
            <el-option key :label="$t('lang.lbl_choose_inspection_typeName2')" :value="zero"></el-option>
            <el-option v-for="(item,index) in maintainType2List" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 报事三级分类 -->
        <el-form-item>
          <el-select v-model="maintainType3" @change="changeSelect3">
            <el-option key :label="$t('lang.lbl_choose_inspection_typeName3')" :value="zero"></el-option>
            <el-option v-for="(item,index) in maintainType3List" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 报事四级分类 -->
        <!-- <el-form-item>
          <el-select v-model="maintainType4" @change="changeSelect4">
            <el-option key :label="$t('lang.lbl_choose_inspection_typeName4')" :value="zero"></el-option>
            <el-option v-for="(item,index) in maintainType4List" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- 报事五级分类 -->
        <!-- <el-form-item>
          <el-select v-model="maintainType5">
            <el-option key :label="$t('lang.lbl_choose_inspection_typeName5')" :value="zero"></el-option>
            <el-option v-for="(item,index) in maintainType5List" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- 关键字搜索 -->
        <el-form-item>
          <el-input class="searchInput" v-model="keyword" :placeholder="$t('lang.lbl_inputInspection_name')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
        <el-upload class="upload-demo" ref="uploading" action :on-remove="handleRemove" :on-change="handleSuccess"
          :on-exceed="outlimit" :on-error="uploadErr1" :limit="1" accept=".xlsx,.xls" :file-list="fileList"
          :auto-upload="false">
          <!-- <el-button slot="trigger" size="small" type="primary">{{$t('lang.btn_selectExcel')}}</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">
            {{$t('导入任务标准')}}</el-button> -->
        </el-upload>
      </el-form>
    </div>
    <el-card>
      <!-- 添加巡检标准 -->
      <el-button type="primary" slot="header" @click="add">{{$t('新增任务标准')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <!-- 复选框 -->
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <!-- 排序id -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- 检查标准名称 -->
        <el-table-column prop="name" :label="$t('lang.lbl_inspection_name')" width="200px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.name&&scope.row.name.length> require('@/config/enum').tableDatamaxlength12"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.name }}
                </span>
              </div>
              <div>
                {{ scope.row.name.substring(0, require('@/config/enum').tableDatamaxlength12) | valueIsNull }}
                <span v-if="scope.row.name.length>require('@/config/enum').tableDatamaxlength12">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.name | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 一级分类 -->
        <el-table-column prop="typeName1" sortable :label="$t('lang.lbl_inspection_typeName1')" width="100px">
        </el-table-column>
        <!-- 二级分类 -->
        <el-table-column prop="typeName2" :label="$t('lang.lbl_inspection_typeName2')" width="100px"></el-table-column>
        <!-- 三级分类 -->
        <el-table-column prop="typeName3" :label="$t('lang.lbl_inspection_typeName3')" width="100px"></el-table-column>
        <!-- 检查方法 -->
        <el-table-column prop="info" :label="$t('lang.lbl_inspection_info')">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.info&&scope.row.info.length> require('@/config/enum').tableDatamaxlength23"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.info }}
                </span>
              </div>
              <div>
                {{ scope.row.info.substring(0, require('@/config/enum').tableDatamaxlength23) | valueIsNull }}
                <span v-if="scope.row.info.length>require('@/config/enum').tableDatamaxlength23">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.info | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 照片 -->
        <el-table-column prop="urls" :label="$t('lang.lbl_inspection_urls')">
          <template slot-scope="scope">
            <viewer :images="scope.row.urls" class="img-width">
              <img v-for="(src,index) in scope.row.urls" :src="src" :key="index" class="img">
            </viewer>
          </template>
        </el-table-column>
        <!-- 修改/删除 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deletetable(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
            <!-- <el-button @click="xlDeviceList(scope.row.id)">{{$t('lang.lab_dePointItem')}}</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:wjPatrolStandardList
   *@Description:检查标准
   *@author:刘彦辰
   *@Copyright:格众科技
   *@date:2020-03-23
   */
  export default {
    name: '/manage/main.wjPatrolStandardList',
    data() {
      return {
        zero: 0, // 值为0的变量
        pageCount: 0, // 总页数
        pageNo: 1, // 第几页
        pageSize: 10, // 每页显示数
        multipleSelection: [], // 多选框
        tableData: [], // 列表数组
        fileList: [], // 上传
        postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
        isDisabled: true, // 保存的可点击
        isPopupPage: false, // 弹框的显示控制
        isAdd: false, // 标识新增(true)或编辑(false)
        diaForm: {
          type: '', // 物业问题/项目问题
          typeId: '', // 问题分类
          name: '', // 问题
          answer: '', // 答案
        },
        typelist: [], // 物业问题/项目问题列表
        keyword: '', // 根据标准名称搜索
        name: '', // 问题
        answer: '', // 答案
        type: 1, // 判断条件类型
        maintainType1: 0, // 1级条件
        maintainType2: 0, // 2级条件
        maintainType3: 0, // 3级条件
        maintainType4: 0, // 4级条件
        maintainType5: 0, // 5级条件
        maintainType1List: [], // 1级条件下拉列表
        maintainType2List: [], // 2级条件下拉列表
        maintainType3List: [], // 3级条件下拉列表
        maintainType4List: [], // 4级条件下拉列表
        maintainType5List: [], // 5级条件下拉列表
        gardenId: ''
      }
    },
    created() {
      this.gardenId = this.$store.getters.gardenId
      setTimeout(() => {
        window.localStorage.setItem('addInspectionStandardform', '')
        window.localStorage.setItem('addInspectionStandardsaveData', '')
      }, 200)
      this.getTablelist()
      this.getmaintainType1List()
    },
    activated() {
      this.getTablelist()
      this.getmaintainType1List()
    },
    methods: {
      // 上传文件的断网
      uploadErr1() {
        if (!navigator.onLine || window.navigator.onLine === false) {
          const loading = this.$loading()
          setTimeout(() => {
            loading.close()
            this.$message.error(this.$i18n.t('lang.lab_Online'))
          }, 500)
        }
      },
      // 文件上传数量超过提醒
      outlimit() {
        this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
      },
      // 移除附件
      handleRemove(file, fileList) {
        console.log('Remove Success!', file, fileList)
        this.fileList = []
        this.uploadFile.length = 0
      },
      // 文件上传
      handleSuccess(e) {
        console.log('Upload Success!', e)
        this.uploadFile = e.raw
      },
      // 导入
      submitUpload() {
        if (this.uploadFile.length < 1) {
          this.$message.warning(this.$i18n.t('lang.lab_pleaseSeletcUploadDoc'))
        } else {
          let formData = new FormData()
          formData.append('excelFile', this.uploadFile)
          let loading = this.$loading()
          this.$postFormData(`/inputPatrolStandardPoint/`, formData).then(
            res => {
              loading.close()
              this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
              this.topics()
              this.fileList = []
            },
            error => {
              loading.close()
              this.$message({
                dangerouslyUseHTMLString: true,
                message: error,
                type: 'warning'
              })
            }
          )
        }
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 列表隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 获取1级筛选条件
      getmaintainType1List() {
        let loading = this.$loading()
        this.$get(`maintainTypes/?type=${this.type}&pageSize=999&pageNo=1&parentId=${this.gardenId}`).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.maintainType1List = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 点击1级筛选条件
      changeSelect1() {
        this.type = 2
        this.maintainType2 = 0
        this.maintainType3 = 0
        this.maintainType4 = 0
        this.maintainType5 = 0
        this.maintainType2List = []
        this.maintainType3List = []
        this.maintainType4List = []
        this.maintainType5List = []
        this.$get(`maintainTypes/?type=${this.type}&Pid=${this.maintainType1}&pageSize=999&pageNo=1`).then(res => {
            if (res && res.errCode === 0) {
              this.maintainType2List = res.list
              // 如果1级报事分类值未空，二级三级列表、值都为空
              if (this.maintainType1 === 0) {
                this.maintainType2List = []
                this.maintainType2 = 0
                this.maintainType3List = []
                this.maintainType3 = 0
                this.maintainType4List = []
                this.maintainType4 = 0
                this.maintainType5List = []
                this.maintainType5 = 0
              }
            }
          },
          error => {
            this.$message.error(error)
          })
      },
      // 点击2级筛选条件
      changeSelect2() {
        this.type = 3
        this.maintainType3 = 0
        this.maintainType4 = 0
        this.maintainType5 = 0
        this.maintainType3List = []
        this.maintainType4List = []
        this.maintainType5List = []
        this.$get(`maintainTypes/?type=${this.type}&Pid=${this.maintainType2}&pageSize=999&pageNo=1`).then(res => {
            if (res && res.errCode === 0) {
              this.maintainType3List = res.list
              // 如果二级列表值为空，三级列表、值为空
              if (this.maintainType2 === 0) {
                this.maintainType3List = []
                this.maintainType3 = 0
                this.maintainType4List = []
                this.maintainType4 = 0
                this.maintainType5List = []
                this.maintainType5 = 0
              }
            }
          },
          error => {
            this.$message.error(error)
          })
      },
      // 点击3级筛选条件
      changeSelect3() {
        this.type = 4
        this.maintainType4 = 0
        this.maintainType5 = 0
        this.maintainType4List = []
        this.maintainType5List = []
        this.$get(`maintainTypes/?type=${this.type}&Pid=${this.maintainType3}&pageSize=999&pageNo=1`).then(res => {
            if (res && res.errCode === 0) {
              this.maintainType4List = res.list
              // 如果二级列表值为空，三级列表、值为空
              if (this.maintainType3 === 0) {
                this.maintainType4List = []
                this.maintainType4 = 0
                this.maintainType5List = []
                this.maintainType5 = 0
              }
            }
          },
          error => {
            this.$message.error(error)
          })
      },
      changeSelect4() {
        this.type = 5
        this.maintainType5 = 0
        this.maintainType5List = []
        this.$get(`maintainTypes/?type=${this.type}&Pid=${this.maintainType4}&pageSize=999&pageNo=1`).then(res => {
            if (res && res.errCode === 0) {
              this.maintainType5List = res.list
              // 如果二级列表值为空，三级列表、值为空
              if (this.maintainType4 === 0) {
                this.maintainType5List = []
                this.maintainType5 = 0
              }
            }
          },
          error => {
            this.$message.error(error)
          })
      },
      // 检查标准
      getTablelist() {
        let loading = this.$loading()
        this.$get(
          `patrolStandard/?pageNo=${this.pageNo}&pageSize=${this.pageSize}&maintainType1=${this.maintainType1}&maintainType2=${this.maintainType2}&maintainType3=${this.maintainType3}&maintainType4=${this.maintainType4}&maintainType5=${this.maintainType5}&keyword=${this.keyword}&gardenId=${this.gardenId}`
          ).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 跳转星朗设备
      xlDeviceList(id) {
        this.$router.push({
          path: '/manage/patrolStandardPoint',
          query: {
            id: id
          }
        })
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getTablelist()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getTablelist()
      },
      // 点击编辑传递参数
      edit(row) {
        window.localStorage.setItem('addInspectionStandardform', '')
        window.localStorage.setItem('addInspectionStandardsaveData', '')
        this.$router.push({
          name: 'wjAddInspectionStandard',
          query: {
            id: row.id,
            maintainType1: row.maintainType1,
            maintainType2: row.maintainType2,
            maintainType3: row.maintainType3,
          }
        })
      },
      // 点击添加跳转页面
      add() {
        window.localStorage.setItem('addInspectionStandardform', '')
        window.localStorage.setItem('addInspectionStandardsaveData', '')
        this.$router.push({
          name: 'wjAddInspectionStandard'
        })
      },
      commit() {
        this.pageNo = 1
        this.getTablelist()
      },
      // 删除
      deletetable(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            this.$delete(`/patrolStandard/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      }
    }
  }
</script>

<style lang="scss">
  .el-tooltip__popper.is-light {
    max-width: 400px;
  }

  .wjPatrolStandardList {
    .img {
      width: 80px;
      height: 50px;
      border: 1px solid lightgray;
      border-radius: 5px;
      padding: 5px;
    }

    .img-width {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      max-width: 320px;
    }
  }
</style>